import { StyleSheet,Dimensions} from 'react-native';
import { SIZES, PALETTE, MQ_TABLET} from '../../constants';
import { MediaQueryStyleSheet } from "react-native-responsive";
const WINDOW_WIDTH = Dimensions.get('window').width;


export default MediaQueryStyleSheet.create({
  mainWrapper:{
      flex:1,
    },
  content: {
    flex: 1,
    paddingHorizontal: 40,
    paddingBottom: 40,
  },
  infoMessage: {
    marginTop: 40,
    marginBottom: 10,
    minHeight: 10,
  },
  changePassword: {
    flex: 1,
  },
  specialCharContainer: {
    flexDirection: 'row',
  },
  label: {
    paddingTop: 10,
  },
  password: {
    minHeight: 80,
  },
  confirmPassword: {
    minHeight: 36,
  },
  support: {
    flex: 0,
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  validationLabels: {
    marginBottom: 30,
  },
  validationLabel: {
    marginBottom: 5,
  },
  buttonStyle:{
    },
  newPasswordTextContains:{
    color: PALETTE.secondaryActive,
    marginBottom: 8
  },
  touchableOpacityEnabled:{
    flex: 1,
    borderRadius:2,
    marginTop:5,
    height:45,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: PALETTE.touchableOpacityEnable
  },
  touchableOpacityDisabled:{
    flex: 1,
    borderRadius:2,
    borderWidth: 1,
    height:45,
    marginTop:5,
    justifyContent: 'center',
    alignItems: 'center',
    borderColor:PALETTE.primaryRadioButtonBorder,
    backgroundColor: PALETTE.touchableOpacityDisable
  },
  textEnabled:{
    color:PALETTE.primaryBackground, 
    fontSize:18, 
    fontStyle: 'normal',
    lineHeight: 24,
  },
  textDisabled:{
    color:PALETTE.primaryRadioButtonBorder, 
    fontSize:18
  },
  marginBottom: {
    marginBottom: 15
  },
  buttonDirection: {
     flexDirection: 'row'
  }

},
{
  [MQ_TABLET]: {
    mainWrapper:{
      flex:1,
      alignItems:'center',
    },
   content: {
     width:WINDOW_WIDTH*0.6,
     alignSelf:'center',
     borderWidth: 2,
     borderColor: PALETTE.primaryStrokeLine,
     marginTop:50,
    },
    buttonStyle:{
      width:WINDOW_WIDTH*0.3,
      alignSelf:'center',
    }

  }
});
